import { Injectable } from '@angular/core';
import { v4 as uuid } from 'uuid';
import { BehaviorSubject, Observable } from 'rxjs';
import { CollectionInfoModel, CollectionBlobInfoModel, Util, ResultInfoModel } from '@phdsoft/common';
import { GaugingElement } from 'src/app/platform/busines-data/SectionElements/InspectionElements/gaugingElement';
import { ElementResultInfo } from 'projects/phdsoft/common/src/lib/models/element-result-info.model';

export type SelectElement = {
  RegionBlob: CollectionBlobInfoModel,
  ResultBlob: ResultInfoModel,
  SelectdElement: GaugingElement
}

@Injectable({ providedIn: 'root' })
export class CollectionState {

  private updating$ = new BehaviorSubject<boolean>(false);
  private prCollection$ = new BehaviorSubject<CollectionInfoModel[]>(null);
  private prCurrentCollection$ = new BehaviorSubject<CollectionInfoModel>(null);
  private prSelectElement$ = new BehaviorSubject<SelectElement>(null);


  set isUpdating(isUpdating: boolean) {
    this.updating$.next(isUpdating);
  }

  get collection(): CollectionInfoModel[] {
    return this.prCollection$.getValue();
  }

  set collection(pCollection: CollectionInfoModel[]) {
    this.prCollection$.next(pCollection);
  }

  get currentCollection$(): Observable<CollectionInfoModel> {
    return this.prCurrentCollection$.asObservable();
  }

  get currentCollection(): CollectionInfoModel {
    return this.prCurrentCollection$.getValue();
  }

  set currentCollection(pCollection: CollectionInfoModel) {
    this.prCurrentCollection$.next(pCollection);
  }

  get selectElement$(): Observable<SelectElement> {
    return this.prSelectElement$.asObservable();
  }

  get selectElement(): SelectElement {
    return this.prSelectElement$.getValue();
  }

  set selectElement(pCollection: SelectElement) {
    this.prSelectElement$.next(pCollection);
  }

  addCollection(pCollection: CollectionInfoModel): void {
    try {
      const currentValue = this.collection;

      if (this.collection?.length >= 0) {
        this.collection = [...currentValue, pCollection];

      } else {
        this.collection = [];
        this.collection.push(pCollection);
      }
    } catch (error) {
      console.error('[CollectionState] addCollection', error);
    }
  }

  changeCurrentCollection(pCollection: CollectionInfoModel): void {
    this.currentCollection = pCollection;
  }

  changeSelectElement(
    regionBlob: CollectionBlobInfoModel,
    resultBlob: ResultInfoModel,
    pElemet: GaugingElement): void {
    this.selectElement = {
      RegionBlob: regionBlob,
      ResultBlob: resultBlob,
      SelectdElement: pElemet
    };
  }

  addElement(pElemet: GaugingElement, pDate: Date, select?: boolean): void {
    const collection = this.collection.find(x => x.TempCollectionId === pElemet.collectionId);
    if (!Util.isNullOrUndefined(collection) && collection.IsTemplate) {
      // collection.ElementsResult
      if (Util.isNullOrUndefined(collection.SectionsIds)) {
        collection.SectionsIds = []
      }
      if (Util.isNullOrUndefined(collection.ElementsResult)) {
        collection.ElementsResult = [];
        collection.RegionId = pElemet.regionId;
      }
      if (!collection.SectionsIds.find(x => x === pElemet.SectionId)) {
        collection.SectionsIds.push(pElemet.SectionId);
      }
      collection.ElementsResult.push({
        Element: pElemet, id: pElemet.Guid,
        IsPlanned: true,
        InsertedRegionId: pElemet.regionId,
        TargetGeometryId: pElemet.targetElementId, TargetGeometryTypeId: pElemet.targetElementType,
        Scope: pElemet.scope, SectionId: pElemet.SectionId
      });
    }
    else {
      let regionBlob = collection.BlobPaths.find(x => x.RegionId === pElemet.regionId);
      if (Util.isNullOrUndefined(regionBlob)) {
        regionBlob = {
          id: uuid() as string,
          DefaultGeoPath: '',
          RenderGeoPath: '',
          PropertiesPath: '',
          FEAPath: '',
          LinearElementsPath: '',
          Label: pElemet.regionName,
          RegionId: pElemet.regionId,
          RegionIds: [pElemet.regionId] as Array<string>,
          ResultBlob: [],
          // Elements: [] as Array<any>
        };
        collection.BlobPaths.push(regionBlob);
      }
      let resultBlob = regionBlob.ResultBlob.find(x => x.Date <= pDate);
      if (Util.isNullOrUndefined(resultBlob)) {
        resultBlob = {
          Date: pDate,
          ElementsResult: [],
          id: uuid() as string
        };
        regionBlob.ResultBlob.push(resultBlob);
      }
      resultBlob.ElementsResult.push({
        Element: pElemet, id: pElemet.Guid,
        IsPlanned: true,
        InsertedRegionId: pElemet.regionId,
        TargetGeometryId: pElemet.targetElementId, TargetGeometryTypeId: pElemet.targetElementType,
        InspectionMethodId: pElemet.Campaign.CollectionInfoModel.CurrentMethodId ?? pElemet.inspectionMethodId, SectionId: pElemet.SectionId,
        Scope: pElemet.scope
      });
      // regionBlob.Elements.push(pElemet);
      if (!Util.isNullOrUndefined(select)) {
        if (select === true) {
          this.changeSelectElement(regionBlob, resultBlob, pElemet);
        }
      }
      else {
        this.changeSelectElement(regionBlob, resultBlob, pElemet);
      }
    }
  }

  removeElement(pElemet: ElementResultInfo, collectionId: string): void {
    const collection = this.collection.find(x => x.TempCollectionId === collectionId);
    if (!Util.isNullOrUndefined(collection)) {
      const regionBlob = collection.BlobPaths.find(x => x.RegionId === pElemet.Element.regionId);
      if (!Util.isNullOrUndefined(regionBlob)) {
        for (const resultBlob of regionBlob.ResultBlob) {
          resultBlob.ElementsResult = resultBlob.ElementsResult.filter(x => x.id !== pElemet.Element.id);
        }
      }
    }
  }

  updatedCollectionIdString(pToReplace: CollectionInfoModel, pCollectionId: string): void {
    const collection = this.collection;
    const updatedFieldTypeIndex = collection.findIndex(c => c.TempCollectionId === pToReplace.TempCollectionId);
    this.collection[updatedFieldTypeIndex].CollectionId = pCollectionId;
    this.collection[updatedFieldTypeIndex].TempCollectionId = pCollectionId;
  }

  resetCollection(): void {
    let currentValue = this.prCollection$.getValue();

    if (currentValue?.length > 0) {
      // this.collection = currentValue.filter(collection => collection.CollectionId === pRemove.CollectionId);
      currentValue.splice(0, currentValue?.length);
      currentValue = [];
    }
  }
}
